import { Strings } from "../../resources/i18n/i18n";

// SearchFilter drops an empty option value and shows the label instead, so "All" needs a sentinel
// that is stripped before the request is sent.
export const COLLECTION_FILTER_ALL = "ALL";

export const COLLECTION_APPROVAL_STATUS = {
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  EXPIRED: "EXPIRED",
  REVERTED: "REVERTED",
};

// built on use, so the labels follow the language chosen at login
export const getStatusFilterOptions = () => [
  { key: 0, value: COLLECTION_FILTER_ALL, label: Strings("allStatuses") },
  {
    key: 1,
    value: COLLECTION_APPROVAL_STATUS.PENDING_APPROVAL,
    label: Strings("paymentRequestPending"),
  },
  {
    key: 2,
    value: COLLECTION_APPROVAL_STATUS.APPROVED,
    label: Strings("paymentRequestApproved"),
  },
  {
    key: 3,
    value: COLLECTION_APPROVAL_STATUS.REJECTED,
    label: Strings("paymentRequestRejected"),
  },
  {
    key: 4,
    value: COLLECTION_APPROVAL_STATUS.EXPIRED,
    label: Strings("paymentRequestExpired"),
  },
  {
    key: 5,
    value: COLLECTION_APPROVAL_STATUS.REVERTED,
    label: Strings("paymentRequestReverted"),
  },
];

export const getPaymentModeFilterOptions = () => [
  { key: 0, value: COLLECTION_FILTER_ALL, label: Strings("allPaymentModes") },
  { key: 1, value: "DEPOSIT", label: Strings("DEPOSIT") },
  { key: 2, value: "TRANSFER", label: Strings("TRANSFER") },
];

export const getBankFilterOptions = (banks) => [
  { key: 0, value: COLLECTION_FILTER_ALL, label: Strings("allBanks") },
  ...(banks || []).map((bank) => ({
    key: bank.id,
    value: String(bank.id),
    label: bank.name,
  })),
];

export const getStatusLabel = (status) => {
  switch (status) {
    case COLLECTION_APPROVAL_STATUS.PENDING_APPROVAL:
      return Strings("paymentRequestPending");
    case COLLECTION_APPROVAL_STATUS.APPROVED:
      return Strings("paymentRequestApproved");
    case COLLECTION_APPROVAL_STATUS.REJECTED:
      return Strings("paymentRequestRejected");
    case COLLECTION_APPROVAL_STATUS.EXPIRED:
      return Strings("paymentRequestExpired");
    case COLLECTION_APPROVAL_STATUS.REVERTED:
      return Strings("paymentRequestReverted");
    default:
      return Strings("NA");
  }
};
